module.exports = __webpack_public_path__ + "img/home-delivery-date-top-img_small@2x.7f0fbbb7.webp";